import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');

class ViewStudent extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			url : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : false,
			posts: [],
			files : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	//base64 photo
	getFiles(files){
		this.setState({ files: files });
		console.log(this.state);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("subform").reset();
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state._subcode && this.state._subname){
			$("#showLoader").show();	
			PostData('subject/addsub',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Subject Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("subform").reset();
					this.getdata();
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('subject/deletesub',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Subject Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();	
		GetData('student/getstudbyid/'+this.props.match.params.ac+'/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();	
			let res = result;
			if(res){
				this.setState({
					url : res[0]['photo'],
					name : res[0]['studentname'],
					regno : res[0]['regno'],
					emisno : res[0]['emisno'],
					rollno : res[0]['rollno'],
					aadhar : res[0]['aadharno'],
					cls : res[0]['cls'],
					sec : res[0]['sec'],
					dob : res[0]['dob'],
					gender : res[0]['gender'],
					bldgrp : res[0]['bloodgroup'],
					communi : res[0]['comm'],
					caste : res[0]['cast'],
					nation : res[0]['nationality'],
					mtongue : res[0]['mothertongue'],
					address : res[0]['presentaddr'],
					mobile : res[0]['mobile'],
					email : res[0]['email'],
					admissionno : res[0]['admissionno'],
					father : res[0]['fathername'],
					mother : res[0]['mothername'],
					fathermobile : res[0]['fathermob'],
					mothermobile : res[0]['mothermob'],
					country : res[0]['country'],
					state : res[0]['state'],
					city : res[0]['city'],
					religion : res[0]['rel'],
					identify1 : res[0]['identify1'],
					identify2 : res[0]['identify2'],
				});
			}
		});
	}
	
	getdob(dob){
		
		var emptydob = '';
		if(dob!='0000-00-00'){
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate() - 1);
			
			var d = new Date(edate),
			month = '' + (d.getMonth() + 1),
			day = '' + (d.getDate() + 1),
			year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('-');
		}
		else{
			
			return emptydob;
		}
	}
	
  render() {
	
	this.state.id = this.props.match.params.id;
	this.state.ac = this.props.match.params.ac;
	
  if(this.state._redirect){
		  
		return (<Redirect to='/student/list' />);
	}
	
	if(this.state.url == ''){
		
		if(this.state.gender == 'Male'){
			this.state.url = GLOBAL.BASE_URL+'/public/avatar/boy.png';
		}
		else{
			this.state.url = GLOBAL.BASE_URL+'/public/avatar/girl.png';
		}
	}
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					   <CardHeader>
						   <span className="pull-right">
							  <Button outline color="primary" onClick={this.onBack}>Back to Student List</Button>
						   </span>
						 </CardHeader>
						<CardBody>
						  <Row>	
							<Col md="10 offset-1">
							  <Card>
								<table>
								  <tbody>
									<tr>
										<td align="center" className="scl-head">{GLOBAL.Sclful_NAME}</td>
									</tr>
									<tr>
										<td align="center" className="scl-head"></td>
									</tr>
									<tr>
										<td align="center" className="scl-head"><u>Student Profile</u></td>
									</tr>
								  </tbody>
								</table>
								<hr></hr>
								<table className="tab-lmargin">
								  <tbody>
									<tr>
										<td><b>Admission No : </b>{this.state.admissionno} </td>
										<td className="photoright"><b>Class :</b> {this.state.cls} <b>&nbsp;&nbsp;&nbsp;&nbsp;Section :</b> {this.state.sec}</td>
									</tr>
								  </tbody>
								</table>
								<hr></hr>
								<table className="tab-margin" width="100%">
								  <tbody>
									<tr>
										<td width="15%"></td>
										<td width="65%"></td>
										<td width="20%" rowSpan="5"><Card className="photoright">
											<img src={this.state.url} width="150px" height="130px"/>
										</Card></td>
									</tr>
									<tr>
										<td className="td-padding"><b>Register No </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.regno} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Student Name </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.name} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>DOB </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.getdob(this.state.dob)} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Gender </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.gender}  </td>
									</tr>
									<tr>
										<td className="td-padding"><b>EMIS No </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.emisno} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Roll No </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.rollno} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Aadhar No </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.aadhar} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Blood Group </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.bldgrp} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Community </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.communi} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Caste </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.caste} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>Father Name </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.father}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Father Mobile </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.fathermobile}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Mother Name </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.mother}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Mother Mobile </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.mothermobile}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Address </b></td>
										<td className="td-padding" colSpan={2}>: &emsp;&emsp;&emsp;{this.state.address} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>City </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.city}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Mobile </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.mobile}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Email </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.email}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Country </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.country} </td>
									</tr>
									<tr>
										<td className="td-padding"><b>State </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.state}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Religion </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.religion}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Nationality </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.nation}</td>
									</tr>
									<tr>
										<td className="td-padding"><b>Mother Tongue </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;{this.state.mtongue}</td>
									</tr>
									{/*<tr>
										<td className="td-padding"><b>Personal Identification </b></td>
										<td className="td-padding">: &emsp;&emsp;&emsp;1. {this.state.identify1}<br></br>2. {this.state.identify2}</td>
									</tr>*/}
								  </tbody>
								</table>
							  </Card>
							</Col>
						  </Row>
						</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default ViewStudent;


// WEBPACK FOOTER //
// ./src/student/Admission/ViewStudent.js